import { Workflow } from './workflow';

export class TypeCredit {
    id: number|undefined;
    active!: boolean;
    code!: string;
    label!: string;
    workflow!: Workflow;
  }
